
import ImagePath from "../../constants/ImagePath";

const SortFilterControls = ({
  sortShow,
  sortCriteria,
  filterShow,
  selectedSubCategory,
  filtering,
}) => {
  return (
    <div className="flex gap-1">
      <button
        onClick={sortShow}
        className="px-1 py-2 rounded-md flex items-center gap-2 text-sm font-semibold overflow-auto hover:text-gray-500"
      >
        <img className="size-6" src={ImagePath.sorting} alt="Sort" />
        Sort: {sortCriteria}
      </button>

      <span className="filter_space">
        &nbsp;<img src={ImagePath.middleline} style={{ height: '20px' }} alt="middle line" />&nbsp;
      </span>

      <button
        onClick={filterShow}
        className="px-1 py-2 rounded-md flex items-center gap-2 text-sm font-semibold hover:text-gray-500"
      >
        <img className="size-6" src={filtering} alt="Filter" />
        {selectedSubCategory}
      </button>
    </div>
  );
};

export default SortFilterControls;
